import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// CSV cell: quote-escape, and blunt spreadsheet formula injection (=, +, -, @, tab, CR) since rows
// can carry text scraped from the web or returned by Apollo/Perplexity.
export function csvCell(v) {
  const s = String(v ?? "");
  const safe = /^[=+\-@\t\r]/.test(s) ? `'${s}` : s;
  return `"${safe.replace(/"/g, '""')}"`;
}
